document.addEventListener('DOMContentLoaded', function () {

    function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    var randomNumberContent = document.querySelectorAll('.random_number');
    for (let index = 0; index < randomNumberContent.length; index++) {
        const element = randomNumberContent[index];
        var randomNumber = getRandomNumber(3, 9);
        element.textContent = randomNumber;
    }
})
